import React, { useEffect, useState } from 'react';
import { Button, Input } from 'antd';
import PropTypes from 'prop-types';
import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import styled from 'styled-components';
import { ModalStyled } from './ModalStyled';

const { TextArea } = Input;

const TextoModal = styled.p`
  font-size: 14px;
`;

function ModalNovaRequisicao({ visible, onOk, onCancel, loading }) {
  const [descricao, setDescricao] = useState('');

  useEffect(() => {
    setDescricao(!visible ? '' : descricao);
  });

  return (
    <ModalStyled
      visible={visible}
      title="Nova Requisição"
      onOk={onOk}
      onCancel={onCancel}
      closeable={false}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={() => onOk(descricao)}
          loading={loading}
        >
          <CustomText color="var(--system-bg)">Confirmar</CustomText>
        </Button>,
        <Button
          key="back"
          onClick={onCancel}
          disabled={loading}
        >
          Cancelar
        </Button>,
      ]}
    >
      <TextoModal>Informe um nome para a nova requisição (opcional):</TextoModal>
      <TextArea
        disabled={loading}
        maxLength={250}
        value={descricao}
        onChange={({ target: { value } }) => setDescricao(value)}
      />
    </ModalStyled>
  );
}

ModalNovaRequisicao.propTypes = {
  visible: PropTypes.bool,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

ModalNovaRequisicao.defaultProps = {
  visible: false,
};

export default ModalNovaRequisicao;
